<template>
    <div class="home">
        <van-loading type="spinner" color="#1989fa" v-if="isLoading"></van-loading>
        <van-swipe
            height="190"
            class="my-swipe"
            :autoplay="3000"
            indicator-color="white"
        >
            <van-swipe-item>
                <h4>应用</h4>
                <img src="@/assets/images/home/bannner.png">
            </van-swipe-item>
        </van-swipe>
        <van-grid
            :gutter="25"
            :column-num="4"
            :border="false"
            :class="{'noMenu': menuData.length < 1}"
        >
            <van-grid-item
                :key="item.id"
                :text="item.name"
                @click="openNav(item)"
                v-for="item in menuData"
            >
                <img v-if="item.css" :src="require(`@/assets/images/home/${item.css}.png`)">
                <img v-else :src="require('@/assets/images/home/m_zw.png')">
                <p>{{ item.name }}</p>
            </van-grid-item>
            <div class="bgIcon"></div>
            <van-button
                round
                type="info"
                size="small"
                class="refresh"
                @click="refresh"
                v-if="menuData.length < 1&&!isLoading"
            >
                刷新
            </van-button>
        </van-grid>
    </div>
</template>

<script>
export default {
    // 主页——销售
    name: 'home-xs',
    components: { },
    props: {},
    data() {
        return {
            // 加载状态
            isLoading: false,
            // 菜单色块数据
            menuData: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        this.isLoading = true;
        // 获取色块数据
        this.homeInit();
    },
    mounted() { },
    destroyed() { },
    methods: {
        openNav(data) {
            this.$router.isBack = 2;
            const newQuery = {};
            if (data.query.length > 0) {
                data.query.forEach(item => {
                    newQuery[item] = true;
                });
            }
            this.$router.push({
                path: data.path,
                query: newQuery,
            });
        },

        // 获取色块数据
        homeInit() {
            this.$axios
                .get('/interfaceApi/basicplatform/usermenu?code=concrete_app')
                .then(res => {
                    if (res.userMenus.length > 0) {
                        res.userMenus[0].children.forEach(item => {
                            item.query = [];
                            if (item.path !== '') {
                                const strs = item.path.split('?');
                                if (strs.length > 1) {
                                    item.query.push(strs[1]);
                                }
                                item.path = strs[0];
                                this.menuData.push(item);
                            }
                        });
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        refresh() {
            this.isLoading = true;
            this.menuData = [];
            this.homeInit();
        },
    },
};
</script>
<style lang="stylus">
.home
    height 100%
    background #244288
    .van-loading
        text-align center
        position fixed
        top 40%
        left 50%
        transform translateX(-50%)
        z-index 3
    .van-swipe
        .van-swipe__track
            height 193rpx !important
        .van-swipe-item
            color #fff
            font-size 20rpx
            line-height 150rpx
            text-align center
            position relative
            img
                width 100%
                height 100%
                border none
            h4
                position: absolute
                top 0
                left 0
                width: 100%
                font-size 18rpx
                color #fff
                line-height 46rpx
        .van-swipe__indicators
            bottom 65rpx
    .van-grid
        background #fff
        border-radius 10rpx 10rpx 0 0
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        padding 20rpx 12rpx !important
        position relative
        z-index 2
        height calc(100% - 193rpx)
        align-items flex-start
        align-content flex-start
        .bgIcon
            display none
        .refresh
            position absolute
            right 20rpx;
            top 20rpx;
        .van-grid-item
            padding-right 0!important
            .van-grid-item__content
                border none
                padding 0
                img
                    width 40rpx
                    height 40rpx
                p
                    margin 0
                    font-size 12rpx
                    margin-top 6rpx
                    width 100%
                    text-align center
                    white-space nowrap
</style>
